export default __webpack_public_path__ + "static/media/The Lost Soul.bad7b9a2.jpg";